import { Card, CardActionArea, CardContent, CardMedia, Stack, Typography } from "@mui/material";
import React from "react";
import folder from "../assets/img/folder_dark3.png";
import folder_dark from "../assets/img/folder_dark2.png";
import { useTheme } from "@emotion/react";

const CardFolder = ({ onClick, value }) => {
 const theme = useTheme();
 const isDarkMode = theme.palette.mode === "dark";
 return (
  <Card
   variant="outlined"
   sx={{ borderRadius: 2, backgroundColor: "inherit" }}
   hover={true}
   onClick={onClick}
  >
   <CardActionArea>
    <CardContent>
     <Stack>
      <CardMedia component="img" image={isDarkMode ? folder : folder_dark} height="100" />
      <Typography variant="caption" textAlign="center" fontSize={12} fontWeight={600}>
       <Typography variant="span">{value?.toUpperCase()}</Typography>
      </Typography>
     </Stack>
    </CardContent>
   </CardActionArea>
  </Card>
 );
};

export default CardFolder;
